import { createSelector } from 'reselect';

const selectTickets = (state: any) => state.tickets;


export const selectTicketsCurrentItem = createSelector([selectTickets], (tickets) => tickets.current);

export const selectTicketsListItems = createSelector([selectTickets], (tickets) => tickets.list);

export const selectTicketsItemById = (itemId: any) =>
    createSelector(selectTicketsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTicketsQueryItems = createSelector([selectTickets], (tickets) => tickets.query);

export const selectTicketsCreatedItem = createSelector([selectTickets], (tickets) => tickets.create);

export const selectTicketsUpdatedItem = createSelector([selectTickets], (tickets) => tickets.update);

export const selectTicketsReadItem = createSelector([selectTickets], (tickets) => tickets.read);

export const selectTicketsDeletedItem = createSelector([selectTickets], (tickets) => tickets.delete);

export const selectTicketsSearchedItems = createSelector([selectTickets], (tickets) => tickets.search);

export const selectTicketsItemsCount = createSelector([selectTickets], (tickets) => tickets.count);

export const selectTicketsItemsFilter = createSelector([selectTickets], (tickets) => tickets.filter);